import clsx from 'clsx'
import { useField } from 'formik'
import { FC } from 'react'
import { useIntl } from 'react-intl'

import { QueueNumberPriorityEnum } from '@models/queueNumber'

export type QueuePriorityRadioGroupFieldProps = React.InputHTMLAttributes<HTMLInputElement> & {
  name: string
}

const QueuePriorityRadioGroupField: FC<QueuePriorityRadioGroupFieldProps> = (props) => {
  const [field] = useField(props)
  const intl = useIntl()

  return (
    <div className="d-flex align-items-center">
      {Object.entries(QueueNumberPriorityEnum)
        // .splice(3, 3)
        .map(([key, value]) => (
          <div
            className="me-10 mt-2"
            key={value}
          >
            <div className="form-check form-check-custom form-check-solid form-check-sm">
              <input
                {...field}
                id={`priority-${value}`}
                value={value}
                className={clsx('form-check-input', {
                  'bg-danger': value === QueueNumberPriorityEnum.Red && value === field.value,
                  'bg-warning': value === QueueNumberPriorityEnum.Yellow && value === field.value,
                  'bg-success': value === QueueNumberPriorityEnum.Green && value === field.value,
                })}
                type="radio"
                checked={value === field.value}
              />
              <label
                className="form-check-label"
                htmlFor={`priority-${value}`}
              >
                {intl.formatMessage({
                  id: `enum.queue_number_priority.${value.toLowerCase()}`,
                })}
              </label>
            </div>
          </div>
        ))}
    </div>
  )
}

export default QueuePriorityRadioGroupField
